export default "__VITE_ASSET__DuR3pVKI__"